import { Component, OnInit, OnDestroy, AfterContentInit, ChangeDetectorRef } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import ScrollOut from "scroll-out";

@Component({
  selector: 'app-bulletin',
  templateUrl: './bulletin.component.html',
  styleUrls: ['./bulletin.component.scss']
})
export class BulletinComponent implements OnInit, OnDestroy, AfterContentInit {

  // Default manual/static bulletin
  manualBulletins: string[] = [
    `WELCOME TO ARYAKULAM INTERNATIONAL SCHOOL`
  ];

  backendBulletins: string[] = [];
  allBulletins: string[] = [];
  sub: Subscription;
  so: any;

  constructor(
    private firebase: AngularFireDatabase,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // 1. Initial display with manual/static bulletin
    this.allBulletins = [...this.manualBulletins];
    setTimeout(() => this.updateMarquee(), 0);

    // 2. Realtime listener to Firebase key 'bulletin'
    this.sub = this.firebase.object('bulletin').valueChanges().subscribe({
      next: (res: any) => {
        if (res) {
          this.parseBulletinData(res);
        } else {
          this.fetchViaRest();
        }
      },
      error: () => {
        this.fetchViaRest();
      }
    });

    // 3. Fast REST fallback
    this.fetchViaRest();
  }

  private parseBulletinData(data: any) {
    let items: string[] = [];
    if (typeof data === 'string' && data.trim() !== '') {
      items = [data.trim()];
    } else if (Array.isArray(data)) {
      items = data
        .map(i => (typeof i === 'string' ? i : (i?.title || i?.text || i?.message || '')))
        .filter(t => typeof t === 'string' && t.trim() !== '');
    } else if (typeof data === 'object' && data !== null) {
      items = Object.keys(data)
        .map(k => {
          const val = data[k];
          return typeof val === 'string' ? val : (val?.title || val?.text || val?.message || '');
        })
        .filter(t => typeof t === 'string' && t.trim() !== '');
    }

    if (items.length > 0) {
      this.backendBulletins = items;
      this.allBulletins = [...this.backendBulletins, ...this.manualBulletins];
    } else {
      this.allBulletins = [...this.manualBulletins];
    }

    this.updateMarquee();
    this.cdr.detectChanges();
  }

  private async fetchViaRest() {
    try {
      const config = (environment as any).firebaseConfig || (environment as any).firebase;
      if (!config || !config.databaseURL) return;
      const dbUrl = config.databaseURL;
      const res = await fetch(`${dbUrl}/bulletin.json`);
      if (res.ok) {
        const json = await res.json();
        if (json) {
          this.parseBulletinData(json);
        }
      }
    } catch (e) {
      console.warn('Bulletin REST fetch notice:', e);
    }
  }

  updateMarquee() {
    const marquee = document.querySelector('.bulletinMarque');
    if (marquee) {
      marquee.innerHTML = this.allBulletins.join(' &nbsp; | &nbsp; ');
    }
  }

  ngAfterContentInit() {
    this.so = ScrollOut({
      onShown: function (el) {
        el.classList.remove('animated');
        void el.offsetWidth;
        el.classList.add('animated');
      }
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.so) {
      this.so.teardown();
    }
  }
}
